import React from "react";

export function Members() {
  return (
    <div className="fqxi-shortcodes-members"></div>
  );
}
